<div 
  [innerHTML]="svg"
></div>
